import { Collapse } from 'bootstrap'

// if scrolled 100px, add class to header
window.addEventListener('scroll', () => {
  const header = document.querySelector('header')
  if (header) {
    header.classList.toggle('scrolled', window.scrollY > 100)
  }
})

const accordions = document.querySelectorAll('.accordion .accordion-item')

// Event-Listener für den Inhaltsbereich (Klicks ignorieren)
for (const body of document.querySelectorAll('.accordion-body')) {
  body.addEventListener('click', (e) => {
    e.stopImmediatePropagation(); // Verhindert das Schließen des Akkordeons
  });
}

for (const accordion of accordions) {
  accordion.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;

    // Verhindere Klicks im Header-Button
    if (target.closest('.accordion-body')) {
      return; // Ignoriere Klicks im Body
    }

    const openAccordion = Collapse.getInstance(
      document.querySelector('.accordion .accordion-collapse.collapse.show')
    );

    if (openAccordion && openAccordion !== accordion) {
      openAccordion.hide();
    }
  });
}

function setBreadcrumbBgColor() {
  const breadcrumb = document.querySelector('#breadcrumb');
  const firstSection = document.querySelector('.entry-content .is-layout-constrained');
  if (breadcrumb) {
    removeBreadcrumbBgColor();
    const bgClass = Array.from(firstSection?.classList || []).find(cls => cls.startsWith('bg-')) || 'bg-white';
    breadcrumb.classList.add(bgClass);
  }
}

setBreadcrumbBgColor();

function removeBreadcrumbBgColor() {
  const breadcrumb = document.querySelector('#breadcrumb');
  if (breadcrumb) {
    const bgClass = Array.from(breadcrumb.classList).find(cls => cls.startsWith('bg-')) || 'bg-white';
    breadcrumb.classList.remove(bgClass);
  }
}